import axios from 'axios';
import { URL_GET_DISPATCH_CUSTOMERS } from 'constants/urls';

const getDispatchCustomers = async () => {
	try {
		const {
			data: { Data },
		} = await axios({
			method: 'GET',
			url: URL_GET_DISPATCH_CUSTOMERS,
			headers: {
				'Content-Type': 'application/json;charset=UTF-8',
			},
			data: null,
		});
		return Data;
	} catch (error) {
		console.log('GETDISPATCHCUSTOMERS FETCHING ERROR :>> ', error);
	}
};

export default getDispatchCustomers;
